"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeType_1 = require("../enums/ChallengeType");
exports.default = vue_1.default.extend({
    name: 'logingrouping',
    props: {},
    computed: {
        currentChallengeType() {
            const challengeType = this.$store.getters.currentChallengeType;
            switch (challengeType) {
                case ChallengeType_1.ChallengeType.StepUp:
                    return ChallengeType_1.ChallengeType.StepUpForgot;
                case ChallengeType_1.ChallengeType.OneTimeCode:
                    return ChallengeType_1.ChallengeType.OneTimeCodeForgotContainer;
                case ChallengeType_1.ChallengeType.CheckSyncResult:
                    return ChallengeType_1.ChallengeType.CheckSyncResultForgot;
                default:
                    return challengeType;
            }
        },
    },
    methods: {
        submitForm(event) {
            void this.$store.dispatch('submitChallenge', this.$store.state.currentChallenge);
            event.preventDefault();
        },
    },
    components: {},
    mounted() {
        var _a;
        let nextChallenge = { ...this.$store.state.configuration.nextRequestedChallenge };
        nextChallenge.ChallengeTypeValue = ChallengeType_1.ChallengeType.StepUp;
        this.$store.commit('currentChallenge', nextChallenge);
        // We had to add this so the selected step up option gets expanded properly.
        // Not sure why it didn't work initally, we'll have to figure this one out later.
        let stepUpChallenge = nextChallenge;
        if (stepUpChallenge) {
            let index = 0;
            let destinationIndex = 0;
            (_a = stepUpChallenge.StepUpCategories) === null || _a === void 0 ? void 0 : _a.forEach(function (category) {
                var _a;
                category.$id = index.toString();
                category.StepUpModel.$id = index.toString();
                (_a = category.StepUpModel.Destinations) === null || _a === void 0 ? void 0 : _a.forEach(function (destination) {
                    destination.$id = destinationIndex.toString();
                    destinationIndex++;
                });
                index++;
            });
        }
    },
});
